import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'simplebar';
import 'simplebar/dist/simplebar.css';
import 'react-quill-new/dist/quill.snow.css';
import ResizeObserver from 'resize-observer-polyfill';
import * as Sentry from '@sentry/react';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

if (process.env.REACT_APP_SENTRY_ENV !== 'local') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

window.ResizeObserver = ResizeObserver;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
